import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Pricing() {
  return (
    <div id="pricing" className="pricing_main">
      <Container>
        <Row>
          <Col md={12}>
            <div className="titlepage">
              <h2>Our Pricing Plans</h2>
              <span>Choose a package that fits your needs</span>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          
          {/* Standard Plan - Featured */}
          <Col lg={4} md={6} sm={12} className="mb-4">
            <div className="pricing-card featured">
              <div className="popular-badge">POPULAR</div>
              <div className="pricing-header">
                <h3>Regular</h3>
                <div className="price">
                  <span className="currency">₹</span>
                  <span className="amount">799</span>
                  <span className="period">/month</span>
                </div>
              </div>
              
              <div className="pricing-features">
                <ul>
                  <li><i className="fa fa-check"></i> All Starter Plans Classes +</li>
                  <li><i className="fa fa-check"></i> Power Yoga</li>
                  <li><i className="fa fa-check"></i> Inter Class Change Flexibility</li>
                  <li><i className="fa fa-check"></i> Personal attention</li>
                  <li><i className="fa fa-times"></i> Class Time Flexibility </li>
                  <li><i className="fa fa-times"></i> Free Guest Allowance</li>
                </ul>
              </div>
              
              <div className="pricing-action">
                <a href="#contact" className="pricing-button">Get Started</a>
              </div>
            </div>
          </Col>
          
          {/* Premium Plan */}
          <Col lg={4} md={6} sm={12} className="mb-4">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Advance</h3>
                <div className="price">
                  <span className="currency">₹</span>
                  <span className="amount">999</span>
                  <span className="period">/month</span>
                </div>
              </div>
              
              <div className="pricing-features">
                <ul>
                  <li><i className="fa fa-check"></i> All Regular Plans Classes +</li>
                  <li><i className="fa fa-check"></i> Advanced Yoga</li>
                  <li><i className="fa fa-check"></i> Group & private sessions</li>
                  <li><i className="fa fa-check"></i> Personal attention & recommendations</li>
                  <li><i className="fa fa-check"></i> Class Time Flexibility</li>
                  <li><i className="fa fa-check"></i> Free Guest Allowance</li>
                </ul>
              </div>
              
              <div className="pricing-action">
                <a href="#contact" className="pricing-button">Get Started</a>
              </div>
            </div>
          </Col>
        </Row>
        
        <Row className="justify-content-center mt-4">
          <Col md={8} className="text-center">
            <p className="pricing-note">
              Additional private sessions can be booked separately.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Pricing;
